import CircularProgress from '@material-ui/core/CircularProgress'
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos'

import Tooltip from 'components/Tooltip'
import { BulkGoalClasses } from '../../types'

interface BulkGoalStepActionsProps {
  activeStep: number
  canGoNext: boolean
  classes: BulkGoalClasses
  disabledReason?: string
  hasCreatedGoals: boolean
  isAdvancingStep: boolean
  isCreatingGoals: boolean
  selectedStoresCount: number
  onNext: () => void
}

const BulkGoalStepActions = ({
  activeStep,
  canGoNext,
  classes,
  disabledReason,
  hasCreatedGoals,
  isAdvancingStep,
  isCreatingGoals,
  selectedStoresCount,
  onNext
}: BulkGoalStepActionsProps) => {
  const selectedGoalsLabel = `${selectedStoresCount} ${selectedStoresCount === 1 ? 'meta' : 'metas'}`
  const tooltipId = `bulk-goal-next-step-${activeStep}`

  return (
    <div className={classes.actionsContainer}>
      <div className={classes.stepActions}>
        {!hasCreatedGoals && (
          <>
            {disabledReason && <Tooltip fixed place='top' id={tooltipId} content={<p>{disabledReason}</p>} />}
            <span
              className={classes.stepActionTooltipTarget}
              data-tip={disabledReason ? true : undefined}
              data-for={disabledReason ? tooltipId : undefined}
            >
              <button className={classes.nextButton} disabled={!canGoNext || isCreatingGoals || isAdvancingStep} onClick={onNext}>
                {activeStep === 4
                  ? isCreatingGoals
                    ? 'Criando metas...'
                    : `Criar ${selectedGoalsLabel}`
                  : 'Próxima etapa'}
                {isAdvancingStep ? (
                  <CircularProgress size={12} style={{ color: '#fff', marginLeft: 10 }} />
                ) : (
                  <ArrowForwardIos style={{ fontSize: 10, marginLeft: 10 }} />
                )}
              </button>
            </span>
          </>
        )}
      </div>
    </div>
  )
}

export default BulkGoalStepActions
